<template>
    <v-sheet @mouseover="mouseover = true"
             @mouseout="mouseover = false"
             class="mx-auto rounded-lg"
             :elevation="hover && mouseover ? 2 : 12">
        <v-subheader class="d-flex justify-center text-h6">{{ header }}</v-subheader>
        <v-skeleton-loader loading v-if="!nft"
                           class="mx-auto"
                           max-width="300"
                           max-height="400"
                           type="card"></v-skeleton-loader>
        <v-container v-if="nft">
            <v-container style="background: black" class="py-12 mb-4">
                <a :href="url" target="_blank" rel="noopener">
                    <div class="_3d animate d-flex justify-center">
                        <v-img class="front rounded-lg" contain height="175" v-if="nft" :src="braPhoto"></v-img>
                        <v-img class="back rounded-lg" contain height="175" v-if="nft" :src="nft.screenshots && nft.screenshots.length ? nft.screenshots[0].url : tagPhoto"></v-img>
                    </div>
                </a>
            </v-container>
            <v-subheader class="d-flex justify-center">Share your new BraNFT™ with the world.</v-subheader>
            <v-container class="d-flex justify-center">
                <ShareNetwork network="sms" :url="share.url" :title="share.title" :hashtags="share.hashtags" :description="share.description">
                    <v-icon>{{ mdiPhoneMessage }}</v-icon>
                </ShareNetwork>
                <ShareNetwork network="email" :url="share.url" :title="share.title" :hashtags="share.hashtags" :description="share.description">
                    <v-icon>{{ mdiEmail }}</v-icon>
                </ShareNetwork>
                <ShareNetwork network="facebook" :url="share.url" :title="share.title" :hashtags="share.hashtags" :description="share.description">
                    <v-icon>{{ mdiFacebook }}</v-icon>
                </ShareNetwork>
                <ShareNetwork network="whatsapp" :url="share.url" :title="share.title" :hashtags="share.hashtags" :description="share.description">
                    <v-icon>{{ mdiWhatsapp }}</v-icon>
                </ShareNetwork>
                <ShareNetwork network="twitter" :url="share.url" :title="share.title" :hashtags="share.hashtags">
                    <v-icon>{{ mdiTwitter }}</v-icon>
                </ShareNetwork>
                <ShareNetwork network="pinterest" :url="share.url" :title="share.title" :hashtags="share.hashtags" :media="share.media">
                    <v-icon>{{ mdiPinterest }}</v-icon>
                </ShareNetwork>
            </v-container>
        </v-container>
    </v-sheet>
</template>
<style scoped>
@keyframes spin {
    0% {
        transform: translateZ(-100px) rotateX(0deg) rotateY(0deg);
    }
    100% {
        transform: translateZ(-100px) rotateX(0deg) rotateY(360deg);
    }
}
._3d {
    transform-style: preserve-3d;
}
.front {
    transform: rotateY(0deg);
    backface-visibility: hidden;
    max-width: 90%;
}
.back {
    position: absolute;
    transform: rotateY(180deg);
    backface-visibility: hidden;
    max-width: 90%;
}
.animate {
    animation: spin 8s infinite ease-in-out;
}
</style>
<script>
import Vue from "vue";
import VueSocialSharing from "vue-social-sharing";

Vue.use(VueSocialSharing);
import {
    mdiPencil,
    mdiCheckboxMarkedCircleOutline,
    mdiCheckboxBlankOutline,
    mdiTwitter,
    mdiFacebook,
    mdiWhatsapp,
    mdiEmail,
    mdiPhoneMessage,
    mdiPinterest,
} from "@mdi/js";

const { EXAMPLE_TOKEN_ID } = process.env;

export default {
    name: "TsNftWidgetShare",
    components: {},
    methods: {},
    props: {
        hover: Boolean,
        nftComponent: Object,
        header: {
            type: String,
            default: 'Share',
        }
    },
    model: {
        event: "change",
    },
    data: function () {
        return {
            EXAMPLE_TOKEN_ID,
            mdiPencil,
            mdiCheckboxMarkedCircleOutline,
            mdiCheckboxBlankOutline,
            mdiTwitter,
            mdiFacebook,
            mdiWhatsapp,
            mdiEmail,
            mdiPhoneMessage,
            mdiPinterest,
            premint_id: null,
            mouseover: false
        };
    },
    computed: {
        nft() {
            return this.nftComponent ? this.nftComponent.nft : { token_id: EXAMPLE_TOKEN_ID };
        },
        braPhoto() {
            const photo =
                this.nft && this.nft.photos
                    ? this.nft.photos.find((photo) => photo.url.match("_bra-"))
                    : undefined;
            return photo ? photo.url : "";
        },
        tagPhoto() {
            const photo =
                this.nft && this.nft.photos
                    ? this.nft.photos.find((photo) => photo.url.match("_tag-"))
                    : undefined;
            return photo ? photo.url : "";
        },
        screenshot() {
            const screenshot = this.nft && this.nft.screenshots && this.nft.screenshots.length ? this.nft.screenshots[0] : undefined;
            return screenshot ? screenshot.url : screenshot;
        },
        tld() {
            return document.domain.match(/[^.]*.com/)[0];
        },
        url() {
            return `https://${document.domain}/braNFT/${this.nft.token_id}`;
        },
        share() {
            return {
                url: this.url,
                title: "I turned my bra into an NFT, a BraNFT™",
                description: `A BraNFT™ is a truly unique crypto asset tied to real world physical assets... literally.  Check mine out here: ${this.url}`,
                quote: `A BraNFT™ is a truly unique crypto asset tied to real world physical assets... literally.`,
                hashtags: "BraNFT, bra, nft",
                media: this.screenshot,
            }
        },
        github() {
            return process.env.NODE_ENV === 'production' ? `github.${this.tld}` : `github-development.${this.tld}`
        }
    },
    mounted() {},
};
</script>
